import PopUp from '@/common/components/PopUp';
import { useEffect, useState } from 'react';
import {
	FormHeader,
	RecipientsListContainer,
	ButtonsContainer,
	Title,
} from './SendAccountingPopUp.styled';
import { Colors } from '@/common/colors/colors';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { sendValidInvoicesReportFiles } from '@/API/repositories/reports';
import Loading from '@/common/components/Loading';
import SubmitButton from '@/common/components/buttons/SubmitButton';
import { getMailingReportsByType } from '@/API/repositories/mailing-report';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import moment from 'moment';

const REPORT_TYPE = 'VALID_INVOICES_REPORT';

const CheckConfigurationPrompt = () => {
	return (
		<div>
			Konfiguracja odbiorców w zakładce{' '}
			<a href='/settings/mailing-reports'>Mailing Reports</a>
		</div>
	);
};

export default function SendAccountingPopUp({ onClose, month, companyId }) {
	const { makeRequest, hasUnfilledRequest } = useRequestsContext();
	const { addMessage } = useMessageQueueContext();

	const [mailingReport, setMailingReport] = useState();

	const handleSend = async (e) => {
		e.preventDefault();

		const payload = { month, company: companyId };

		makeRequest(sendValidInvoicesReportFiles.bind(null, payload));

		onClose();
	};

	const loadMailingReport = async () => {
		const response = await makeRequest(
			getMailingReportsByType.bind(null, REPORT_TYPE),
		);

		if (!response?.data) {
			return addMessage('Something went wrong', 'error');
		}

		setMailingReport(response.data);
	};

	const lastRequestDateFormatted = mailingReport?.lastRequest?.created_at
		? moment(mailingReport.lastRequest.created_at).format('DD.MM.YYYY HH:mm')
		: null;

	useEffect(() => {
		loadMailingReport();
	}, []);

	const mailingReportNotFound =
		!hasUnfilledRequest(sendValidInvoicesReportFiles) && !mailingReport;
	const isRecipientsValid = mailingReport?.recipients.length > 0;

	return (
		<PopUp setShow={onClose}>
			{hasUnfilledRequest(sendValidInvoicesReportFiles) && <Loading />}
			<form onSubmit={handleSend}>
				<FormHeader>
					{mailingReportNotFound
						? 'Nie znaleziono konfiguracji raportu'
						: 'Czy na pewno chcesz wysłać raport ze wszystkich rynków?'}
				</FormHeader>
				{mailingReport?.lastRequest?.created_at && (
					<p>
						Raport ostatnio wysłany <strong>{lastRequestDateFormatted}</strong>{' '}
						przez <strong>{mailingReport.lastRequest?.triggerBy}</strong>.
					</p>
				)}
				{mailingReportNotFound ? (
					<CheckConfigurationPrompt />
				) : !isRecipientsValid ? (
					<>
						<p>Brak odbiorców</p>
						<CheckConfigurationPrompt />
					</>
				) : (
					<>
						<Title>
							<strong>
								Odbiorcy: <span style={{ color: Colors.red }}>*</span>
							</strong>
						</Title>
						<RecipientsListContainer>
							<ul>
								{mailingReport.recipients.map((r) => (
									<li>{r}</li>
								))}
							</ul>
							<CheckConfigurationPrompt />
						</RecipientsListContainer>
						<ButtonsContainer>
							{isRecipientsValid && (
								<SubmitButton
									style={{ marginBottom: '-35px', height: '35px' }}
									color={Colors.orange}
									text={`Wyślij`}
								/>
							)}
						</ButtonsContainer>
					</>
				)}
			</form>
		</PopUp>
	);
}
